import { TGamePhase } from "./gameContext";
import { ETownSize } from "./town";

export type TBuilding = {
    Name: TGamePhase;
    Top: number;
    Left: number;
    Width: number;
    Height: number;
    Size: ETownSize;
}

type TBuildingTemplate = Pick<TBuilding, "Name" | "Width" | "Height"> 

export const buildingTemplatesBySize: Record<ETownSize, TBuildingTemplate[]> = {
    [ETownSize.Small]: [
        {Name: "Saloon", Width: 157, Height: 244},
        {Name: "Jail", Width: 157, Height: 244},
        {Name: "General Store", Width: 157, Height: 244},
        {Name: "Telegraph Office", Width: 157, Height: 244}
    ],
    [ETownSize.Medium]: [ 
        {Name: "Barber", Width: 158, Height: 244},
        {Name: "Undertaker", Width: 158, Height: 244}
    ],
    [ETownSize.Large]: [
        {Name: "Blacksmith", Width: 158, Height: 244},
        {Name: "Bank", Width: 158, Height: 244}
    ]
}


// AI has just guessed at the boxes
export const Buildings: TBuilding[] = [
    {Name: "Saloon", Top: 55, Left: 6, Width: 157, Height: 244, Size: ETownSize.Small},
    {Name: "Jail", Top: 55, Left: 165, Width: 157, Height: 244, Size: ETownSize.Small},
    {Name: "General Store", Top: 55, Left: 1920-(157+20), Width: 157, Height: 244, Size: ETownSize.Small},
    {Name: "Telegraph Office", Top: 55, Left: 1920-(157+157+22), Width: 157, Height: 244, Size: ETownSize.Small},
    // TODO: Add the rest of the buildings
    // {Name: "Barber", Top: 50, Left: 516, Width: 158, Height: 244, Size: ETownSize.Medium},
    // {Name: "Undertaker", Top: 50, Left: 516+160, Width: 158, Height: 244, Size: ETownSize.Medium},
    // {Name: "Blacksmith", Top: 50, Left: 1000, Width: 158, Height: 244, Size: ETownSize.Large},
    // {Name: "Bank", Top: 50, Left: 1000+160, Width: 158, Height: 244, Size: ETownSize.Large},

    // AI suggestions of additional buildings
    // {Name: "Sheriff", Top: 55, Left: 1278, Width: 157, Height: 244, Size: ETownSize.Small},
    // {Name: "Hotel", Top: 55, Left: 1437, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "Church", Top: 55, Left: 1596, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "School", Top: 55, Left: 1755, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "Doctor", Top: 55, Left: 1914, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "Lawyer", Top: 55, Left: 2073, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "Gunsmith", Top: 55, Left: 2232, Width: 157, Height: 244, Size: ETownSize.Medium},
    // {Name: "Post Office", Top: 55, Left: 2391, Width: 157, Height: 244, Size: ETownSize.Small},
    // {Name: "Stable", Top: 55, Left: 2550, Width: 157, Height: 244, Size: ETownSize.Small},
    // {Name: "Livery", Top: 55, Left: 2709, Width: 157, Height: 244, Size: ETownSize.Small},
    // {Name: "Cemetery", Top: 55, Left: 2868, Width: 157, Height: 244, Size: ETownSize.Small}


]